// Метаданные 10 экранов. Доступный набор приходит с сервера (user.screens).
export type ScreenKey =
  'dash' | 'deals' | 'catalog' | 'pay' | 'plan' | 'prod' | 'supply' | 'ship' | 'kpp' | 'settings';

export type ScreenMeta = { key: ScreenKey; name: string; ico: string; path: string };

export const SCREENS: ScreenMeta[] = [
  { key: 'dash', name: 'Обзор', ico: '📊', path: '/dash' },
  { key: 'deals', name: 'Сделки', ico: '📋', path: '/deals' },
  { key: 'catalog', name: 'Конструктор', ico: '🧩', path: '/catalog' },
  { key: 'pay', name: 'Платежи', ico: '🧾', path: '/pay' },
  { key: 'plan', name: 'Календарь', ico: '📅', path: '/plan' },
  { key: 'prod', name: 'Производство', ico: '🏭', path: '/prod' },
  { key: 'supply', name: 'Закуп · склад', ico: '📦', path: '/supply' },
  { key: 'ship', name: 'Отгрузка', ico: '🚚', path: '/ship' },
  { key: 'kpp', name: 'КПП', ico: '🛡️', path: '/kpp' },
  { key: 'settings', name: 'Настройки', ico: '⚙️', path: '/settings' },
];

export const screensFor = (allowed: string[]): ScreenMeta[] =>
  SCREENS.filter((s) => allowed.includes(s.key));
